import { TMenuNode } from '../components/types';

/**
 * Check if the item has an active child
 *
 * @param {*} {item: TMenuNode}
 * @return {*}  {boolean}
 */
export const hasActiveChild = ({
    item,
    pathname,
}: {
    item: TMenuNode;
    pathname: string;
}): boolean => {
    if ('path' in item) {
        return pathname === item.path;
    }
    if ('items' in item) {
        return item.items.some((child) =>
            hasActiveChild({ item: child, pathname })
        );
    }
    return false;
};
